import React, { memo } from 'react';
import { BaseToast, BaseToastProps } from 'react-native-toast-message';
import { useToastStyles } from '../hooks/useToastStyles';
import Icon from '../../Icon/Icon';

function ErrorToast(props: BaseToastProps) {
  const { baseStyle, errorStyle, containerStyle, errorTextStyle } =
    useToastStyles();

  return (
    <BaseToast
      {...props}
      renderLeadingIcon={() => (
        <Icon name="warning" color="iconSecondary" width={18} height={18} />
      )}
      style={{ ...errorStyle, ...baseStyle, height: 'fit-content' }}
      contentContainerStyle={containerStyle}
      text1Style={{ ...errorTextStyle, fontWeight: '600' }}
      text2Style={errorTextStyle}
      text2NumberOfLines={10}
    />
  );
}

export default memo(ErrorToast);
